const SUPER_ADMIN_LABELS = new Set([
  "superadmin",
  "super-admin",
  "super_admin",
  "super administrator",
]);

export const ROLE_ALIASES = {
  SuperAdmin: "Salesperson",
};

export const FALLBACK_ROLE = "Salesperson";

export const isSuperAdminRole = (role) => {
  if (!role) {
    return false;
  }
  const normalized = role.toString().trim().toLowerCase();
  return SUPER_ADMIN_LABELS.has(normalized);
};

export const normalizeRoleForRouting = (role) => {
  if (!role) {
    return FALLBACK_ROLE;
  }
  if (isSuperAdminRole(role)) {
    return ROLE_ALIASES.SuperAdmin;
  }
  return role;
};

export const getRoleBasePath = (role) =>
  `/${normalizeRoleForRouting(role).toLowerCase()}`;
